import React from 'react';
import { ScrollParallax } from "react-just-parallax";
import { Link } from 'react-router-dom';
import DefaultButton from './DefaultButton';

function MinimalSection({ orientation, background, title, description, href, imageUrl, titleClass, subtitle, descriptionClass, buttonText, darkButton, strength, lerp, imgOpacity, firstButtonText, buttonClass1, buttonClass2, secondButton, secondButtonText, href2 }) {


  return (
    <>
    {orientation === 'left' ? (
        <>
            <section>
                <div className='mx-auto'>
                    <div className='h-lvh flex justify-center items-center'>
                        <div className={`${imgOpacity} h-lvh hidden sm:block sm:w-[100%] z-0`}>
                            {/* <ScrollParallax lerpEase={lerp} zIndex='0' enableOnTouchDevice={false} strength={strength}> */}
                                <img src={imageUrl} alt={title} className='w-full h-full object-cover' />
                            {/* </ScrollParallax> */}
                        </div> 
                        <div className={`h-lvh w-full sm:w-3/5 ${background} flex justify-center items-center p-4 z-20`}>
                            <div className='flex flex-col justify-center items-start text-left w-full sm:max-w-md lg:max-w-lg xl:max-w-xl mx-auto'>
                                <p className="text-3xl text-white mb-10 uppercase">{subtitle}</p>
                                <h1 className={`lg:text-4xl md:text-3xl font-semibold mb-2 ${titleClass} text-balance`} data-aos="fade-up" data-aos-duration="900">{title}</h1>
                                <div data-aos="fade-zoom-in" data-aos-duration="1000" className={` text-lg mb-4 ${descriptionClass} text-balance`}>{description}</div>
                                <DefaultButton text={firstButtonText || 'Scopri di più'} link={href} dark={darkButton} buttonClass={buttonClass1} />
                                {secondButton && <DefaultButton text={secondButtonText || 'Scopri di più'} link={href2} dark={darkButton} buttonClass={buttonClass2} />}
                            </div>
                        </div>   
                    </div>
                </div>
            </section>
        </>
    ) : (
        <>
            <section>
                <div className='mx-auto'>
                    <div className='h-lvh flex justify-center items-center'>
                        <div className={`h-screen w-full sm:w-3/5 ${background} flex justify-center items-center p-4 z-20`}>
                            <div className='text-left w-full sm:max-w-md lg:max-w-lg xl:max-w-xl mx-auto'>
                                <p className="text-3xl text-white mb-10 uppercase">{subtitle}</p>
                                <h1 className={`lg:text-4xl md:text-5xl font-semibold mb-2 ${titleClass} text-balance`} data-aos="fade-up" data-aos-duration="900">{title}</h1>
                                <div data-aos="fade-zoom-in" data-aos-duration="1000" className={` text-lg mb-4 ${descriptionClass} text-balance`} >{description}</div>
                                <DefaultButton text={firstButtonText || 'Scopri di più'} link={href} dark={darkButton} buttonClass={buttonClass1} />
                                {secondButton && <DefaultButton text={secondButtonText || 'Scopri di più'} link={href2} dark={darkButton} buttonClass={buttonClass2} />}
                            </div>
                        </div>  
                        <div className={`${imgOpacity} h-lvh hidden sm:block sm:w-2/5 z-0`}>
                            {/* <ScrollParallax lerpEase={lerp} zIndex='0' enableOnTouchDevice={false} strength={strength}> */}
                                <img src={imageUrl} alt={title} className='w-full h-full object-cover' />
                            {/* </ScrollParallax> */}
                        </div>  
                    </div>
                </div>
            </section>
        </>
    )}
    </>
  );
}

export default MinimalSection;


